/*eslint-disable*/
import React from 'react'
import { useTranslation } from 'react-i18next'

// components
import TextField from '@mui/material/TextField'
import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import SearchIcon from '../../../../assets/Search.svg'

// hooks
import usePreviousSearchText from '../../../../hooks/usePreviousSearchText'

const SearchBar = ({ searchText, setSearchText, getUsers }) => {
  const { t } = useTranslation();
  const { previousSearchText, setPreviousSearchText } =
    usePreviousSearchText(searchText)

  const handleSearch = (e) => {
    const { value } = e?.target
    setSearchText(value)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && searchText !== previousSearchText) {
      setPreviousSearchText(searchText)
      getUsers(searchText)
    }
  }

  return (
    <div
      style={{
        marginLeft: '80px',
        marginRight: '80px',
        marginBottom: '3px',
        backgroundColor: '#F5F5F5',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <TextField
        placeholder={t("view-edit-user-search-placeholder")}
        value={searchText}
        size="small"
        onChange={handleSearch}
        onKeyDown={handleKeyDown}
        style={{
          borderBottom: '1px solid #C1BBB3',
          paddingTop: '12px',
          paddingBottom: '11px',
        }}
        InputProps={{
          startAdornment: (
            <div style={{ marginRight: '16px' }}>
              <img
                src={SearchIcon}
                alt=""
                style={{ 
                  height: '32px',
                  pointerEvents: 'none',
                  userSelect: 'none',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              />
            </div>
          ),
          endAdornment: searchText?.length > 0 && (
            <IconButton onClick={() => setSearchText('')}>
              <CloseIcon />
            </IconButton>
          ),
        }}
        sx={{
          width: '875px',
          padding: '10px 10px 10px 2px',
          border: '0px 0px 1px 0px',
          gap: '10px',
          backgroundColor: 'white',
          '& .MuiInputBase-input::placeholder': {
            color: '#564C47',
            opacity: 1,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none', // Remove the border
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none', // Remove the border on hover
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none', // Remove the border when focused
          },
        }}
      />
    </div>
  )
}

export default SearchBar
